// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"37":"6ee563f77d15c0667df4","446":"883d78f1a5fc4aadc24b","540":"55353bb8d71a0fe26479","961":"55ebcfddd3366a78c394"}[chunkId] + ".js";
};